<template>
  <div>
    <h2 class="text-white mb-4">Instagram</h2>
    <div id="instafeed" class="row"></div>
  </div>
</template>

<script>

export default {
  name: 'Insta',
  data () {
    return {
      instaUrl: 'https://graph.instagram.com/me/media?fields=caption,id,media_type,media_url,permalink,thumbnail_url,timestamp,username&access_token=',
      postSize: 4,
      instaFeeds: [],
      token: null
    }
  },
  computed: {
    url: function () {
      return `${process.env.MIX_APP_URL}/`
    }
  },
  methods: {
    getToken () {
      const self = this
      self.axios.get('/insta.json').then(resp => {
        self.token = resp.data.access_token
        /*eslint-disable */
        const feed2 = new Instafeed({
          accessToken:
          self.token,
          template:
            '<div class="col-md-3 mb-4">' +
            '<div class="insta-box"><a href="{{link}}"  target="_blank"><img title="{{caption}}" src="{{image}}" class="w-100 insta-img" /><div></div></div></div>',
          limit: 4,
          target: 'instafeed'
        })
        feed2.run()
        /* eslint-enable */
      })
    }
  },
  mounted () {
    const self = this
    self.getToken()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Insta.vue